<template>
    <div class="buyerBindingRule">
        <div class="modeBox">
            <el-popover placement="bottom" width="200" trigger="hover" v-for="(item, index) in ruleArr" :key="index">
                <div class="tipsText">
                    <div class="tipsHtml" style="padding: 10px" v-html="item.tipsText"></div>
                </div>
                <div slot="reference" @click="clickMode(index + 1)" :class="{'modeItem': true, 'borderColor': index + 1 === params.clientbindmode}">
                    <i class="el-icon-info"></i>
                    <p class="modeTitle">{{item.modeTitle}}</p>
                    <p class="modeValidity"><span v-if="item.modeTitle === '自定义'">有效期：</span>{{item.validity}}</p>
                    <p class="modeRobAnswer">{{item.robAnswer}}</p>
                    <p v-if="item.modeTitle === '自定义'" class="settingBox"><span class="setting" @click.stop="settingMode">设置</span></p>
                    <i class="el-icon-success"></i>
                </div>
            </el-popover>
        </div>
        <p class="modeTips">模式修改后立即生效，每天只能修改一次</p>
        <BuyerBindingSetting ref="buyerBindingSetting" @setParams="setParams" :data="selfRule"></BuyerBindingSetting>
        <OtherRulePop @cancel="cancel" @affirm="affirm" ref="otherRulePop"></OtherRulePop>
    </div>
</template>
<script>
import BuyerBindingSetting from './buyerBindingRule/buyerBindingSetting'
import OtherRulePop from './buyerBindingRule/otherRulePop'
export default {
    name: 'buyerBindingRule',
    data() {
        return {
            ruleArr: [
                {modeTitle: '简单模式', validity: '客户永久有效', robAnswer: '不允许抢客', tipsText: '推广员A与买家B已绑定为客户关系；<br>若B购买了商品则算推广员A的业绩，不会被其他推广员抢走。'},
                {modeTitle: '平衡模式', validity: '客户15天内有效', robAnswer: '不允许抢客', tipsText: '推广员A与买家B已绑定为客户关系；<br>在15天内，绑定关系不变，若B购买了商品则算推广A的业绩。'},
                {modeTitle: '竞争模式', validity: '客户15天内有效', robAnswer: '客户随时可被抢走', tipsText: '推广员A与买家B已绑定为客户关系；<br>在15天内，若B购买了商品，则算推广员A的业绩；<br>若B通过推广员C的推广链接购买，则业绩属于推广员C。'},
                {modeTitle: '自定义', validity: '15天', robAnswer: '不允许抢客', tipsText: '可设置有效期：永久有效，<br>或自定义有效期<br>可设置抢客：不可抢客，或指定时间过后可以抢客'}
            ],
            select: '',
            params: {
                clientbindmode: 1,
                clientbinddays: 0,
                changeclientbinddays: 0
            },
            selfRule: ''
        }
    },
    props: ['data'],
    created() {
    },
    watch: {
        'data': {
            handler() {
                for (let key in this.params) {
                    this.params[key] = this.data[key]
                }
                this.selfRule = this.data
                if (this.data.clientbindmode === 4) {
                    if (this.data.changeclientbinddays === 0) {
                        this.ruleArr[3].robAnswer = '不允许抢客'
                    } else {
                        this.ruleArr[3].robAnswer = '允许抢客'
                    }
                    if (this.data.clientbinddays === 0) {
                        this.ruleArr[3].validity = '永久有效'
                    } else {
                        this.ruleArr[3].validity = `${this.data.clientbinddays}天`
                    }
                }
                
            },
            deep: true
        }
    },
    methods: {
        clickMode(index) {
            this.select = index
            // this.params.clientbindmode = index
            if (index !== this.params.clientbindmode) {
                this.$refs.otherRulePop.dialogVisible = true
            }
        },
        settingMode() {
            this.$refs.buyerBindingSetting.centerDialogVisible = true
        },
        // 取消改变模式
        cancel() {

        },
        // 确认改变模式
        affirm() {
            this.params.clientbindmode = this.select
            if (this.select === 1) {
                this.params.clientbinddays = 0
                this.params.changeclientbinddays = 0
            } else if (this.select === 2) {
                this.params.clientbinddays = 15
                this.params.changeclientbinddays = 0
            } else if (this.slelect === 3) {
                this.params.clientbinddays = 15
                this.params.changeclientbinddays = 0
            }
        },
        setParams(v) {
            if (v.clientbinddays) {
                this.params.clientbinddays = Number(v.validate)
                this.ruleArr[3].validity = `${v.validate}天`
            } else {
                this.params.clientbinddays = 0
            }
            if (v.changeclientbinddays) {
                this.ruleArr[3].robAnswer = '允许抢客'
                this.params.changeclientbinddays = Number(v.bindnum)
            } else {
                this.params.changeclientbinddays = 0
                this.ruleArr[3].robAnswer = '不允许抢客'
            }
        }
    },
    components: {
        BuyerBindingSetting, OtherRulePop
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .buyerBindingRule{
        .modeBox{
            display: flex;
            .modeItem{
                border: 1px solid #DCDFE6;
                width: 156px;
                height: 176px;
                box-sizing: border-box;
                text-align: right;
                padding: 10px;
                margin-right: 60px;
                cursor: pointer;
                position: relative;
                .el-icon-info{
                    color: #C0C4CC;
                }
                .el-icon-success{
                    color: #409EFF;
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    font-size: 24px;
                    display: none;
                }
                .modeTitle{
                    font-size: 16px;
                    font-weight: 500;
                    color: #303133;
                    line-height: 20px;
                    text-align: center;
                    margin-top: 10px;
                }
                .modeValidity{
                    margin-top: 15px;
                }
                .modeValidity, .modeRobAnswer{
                    text-align: center;
                    font-size: 12px;
                    line-height: 20px;
                }
                .settingBox{
                    text-align: center;
                    padding-top: 20px;
                    .setting{
                        color: #409EFF;
                        display: inline-block;
                    }
                }
            }
            .borderColor{
                border: 1px solid #409EFF;
                .el-icon-success{
                    display: block;
                }
            }
        }
        .modeTips{
            color: #909399;
            margin-top: 20px;
        }
    }
</style>